// Upper-cases the first character by the language's own rules — for a label that stands on
// its own (a button, the head of a line) where the language writes the word lowercase
// mid-sentence: Spanish weekdays ("vie") and language names ("español").
export const capitalizeFirst = (text, locale) =>
  text ? text.charAt(0).toLocaleUpperCase(locale) + text.slice(1) : text;

